export * from './add-object-modal/add-object.component';
export * from './feedback-modal/feedback-modal.component';
export * from './select-object-modal/select-object-modal.component';
export * from './settings-modal/settings-modal.component';
export * from './tariff-modal/tariff-modal.component';
export * from './update-password-modal/update-password-modal.component';
export * from './change-object-name/change-object-name-modal.component';
export * from './change-device-phone/change-device-phone-modal.component';
export * from './profile-modal/profile-modal.component';
export * from './send-capcha/send-capcha.component';
export * from './share-device-modal/share-device-modal.component';
export * from './share-device-confirm-modal/share-device-confirm-modal.component';
export * from './share-device-cancel-modal/share-device-cancel-modal.component';
export * from './service-order-modal/service-order-modal.component';
export * from './confirm-deleting-modal/confirm-deleting-modal.component';



// WEBPACK FOOTER //
// ./src/app/view/modal/index.ts